import React, { Component } from 'react'
import LazyLoader from 'utilities/LazyLoader'
import { withTranslation } from 'react-i18next'


const loadTenantApp = (tenantName) => {
  /*
     Add tenants to this switch change the entire App.js
  */
  switch (tenantName) {
    default:
      return import(`./_default`)
  }
}

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menuActive: false,
      modalActive: '',
      modalId: '',
      modalString: '',
    }
  }

  render = () => {
    return <LazyLoader
      loader={loadTenantApp}
      tenantName={window.Tenant}
      {...this.props}
    />
  }
}

// export default withRouter(translate([], {})(connect(mapStateToProps, mapDispatchToProps)(App)));
export default withTranslation('common')(App)
